/**
 * Story 41 (jupiter slice) — RN6: dynamic inner separator for array/isSimpleData CSV columns
 * (e.g. `operators`). Used by SmartMateriaUIToolbar's CSV export instead of the array's default
 * toString(), which always joins with a bare "," and can collide with the CSV field separator.
 */

const FIELD_SEPARATOR_SEMICOLON = ';'
const ARRAY_INNER_SEPARATOR_WHEN_SEMICOLON_FIELD = ', '
const ARRAY_INNER_SEPARATOR_DEFAULT = '; '

// RN6: choose the inner separator so it never collides with the CSV field separator.
export const getArrayInnerSeparator = (fieldSeparator) =>
  fieldSeparator === FIELD_SEPARATOR_SEMICOLON
    ? ARRAY_INNER_SEPARATOR_WHEN_SEMICOLON_FIELD
    : ARRAY_INNER_SEPARATOR_DEFAULT

// S12: absent/empty operators export as an empty cell (no "null", no separators).
// S10/S11: join with the dynamic inner separator instead of the array's default toString().
export const serializeCsvArrayCell = (value, fieldSeparator) => {
  if (!Array.isArray(value) || value.length === 0) return ''
  return value.join(getArrayInnerSeparator(fieldSeparator))
}

// Story 222: a column path that crosses a list (`deviceTypes.name`) exports the sub-path of each
// element instead of the elements themselves (which `join` rendered as "[object Object]").
// Before the list the walk keeps today's semantics (a segment that is not in the object leaves the
// walk where it was) so scalar columns export exactly as before.
export const walkCsvField = (row, field) => {
  const segments = field.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.')
  let current = row
  for (let i = 0; i < segments.length; i++) {
    if (Array.isArray(current)) {
      return pickFromEachElement(current, segments.slice(i))
    }
    const key = segments[i]
    if (current !== null && typeof current === 'object' && key in current) {
      current = current[key]
    }
  }
  return current
}

const pickFromEachElement = (elements, segments) =>
  elements.map((element) => pickFromElement(element, segments)).filter(isExportable)

// A list of strings (`isSimpleData`, e.g. features' `toolReferences.code`) exports the strings themselves.
const pickFromElement = (element, segments) => {
  if (element === null || typeof element !== 'object') return element
  return segments.reduce(
    (current, key) => (current !== null && typeof current === 'object' ? current[key] : undefined),
    element
  )
}

const isExportable = (value) => value !== null && value !== undefined && value !== ''
